import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsEmojiSvg } from './WpsEmojiSvg'

export const WpsEmojiIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsEmojiSvg} {...props} />
}
